import { ILopTinChiActionTypes } from "../../action-types/lop-tin-chi/ILopTinChiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ILopTinChiReducer } from "../../reducer-model/lop-tin-chi/ILopTinChiReducer";
const iniState: ILopTinChiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    lopTinChis: [],
    filter: {
        hoc_ky: 0,
        nam_hoc: "",
        id_chuyen_nganh: 0,
        id_he: 0,
        khoa_hoc: 0,
        ky_dang_ky: 0,
        stu_nhomlop_id: 0
    },
    lopTinChiFocusedId: 0,
    selectedIds: [],
}
export const lopTinChiReducer = (state: ILopTinChiReducer = iniState, actions: ILopTinChiActionTypes): ILopTinChiReducer => {
    switch (actions.type) {

        case "LOP_TIN_CHI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "LOP_TIN_CHI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                lopTinChis: actions.payload
            }
        case "LOP_TIN_CHI_LOAD_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "LOP_TIN_CHI_CHANGE_FILTER":
            return {
                ...state,
                filter: actions.payload
            }
        case "LOP_TIN_CHI_INI_BY_KE_HOACH_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "LOP_TIN_CHI_INI_BY_KE_HOACH_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "LOP_TIN_CHI_INI_BY_KE_HOACH_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "LOP_TIN_CHI_CHANGE_FOCUSED_ID":
            return {
                ...state,
                lopTinChiFocusedId: actions.payload
            }
        case "LOP_TIN_CHI_CHANGE_SELECTED_IDS":
            return {
                ...state,
                selectedIds: actions.payload
            }
        case "LOP_TIN_CHI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting
            }
        case "LOP_TIN_CHI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                selectedIds: []
            }
        case "LOP_TIN_CHI_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "LOP_TIN_CHI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                lopTinChiEditing: actions.payload
            }
        case "LOP_TIN_CHI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                lopTinChiEditing: undefined
            }
        case "LOP_TIN_CHI_SAVE_START":
            return {
                ...state,
                lopTinChis: state.lopTinChis.map(l => {
                    if (l.id_lop_tc === actions.payload.id_lop_tc) {
                        return {
                            ...l,
                            ...actions.payload
                        }
                    }
                    return { ...l };
                }),
                status: eReducerStatusBase.is_saving
            }
        case "LOP_TIN_CHI_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                isShowEditModal: false,
                lopTinChiEditing: undefined
            }
        case "LOP_TIN_CHI_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "LOP_TIN_CHI_UPDATE_PHAM_VI":
            return {
                ...state,
                lopTinChis: state.lopTinChis.map(l => {
                    if (l.id_lop_tc === actions.payload.id_lop_tc) {
                        return {
                            ...l,
                            phamVis: actions.payload.phamVis
                        }
                    }
                    return { ...l };
                })
            }
        case "LOP_TIN_CHI_LOAD_BY_KE_HOACH_MON_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "LOP_TIN_CHI_LOAD_BY_KE_HOACH_MON_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                lopTinChis: actions.payload
            }
        case "LOP_TIN_CHI_LOAD_BY_KE_HOACH_MON_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "LOP_TIN_CHI_LOAD_BY_DOT_THI_DANG_KY_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            }
        case "LOP_TIN_CHI_LOAD_BY_DOT_THI_DANG_KY_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                lopTinChis: actions.payload
            }
        case "LOP_TIN_CHI_LOAD_BY_DOT_THI_DANG_KY_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "LOP_TIN_CHI_UPDATE_MON_TIN_CHI_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "LOP_TIN_CHI_UPDATE_MON_TIN_CHI_SUCCESS":
            return {
                ...state,
                lopTinChis: state.lopTinChis.map(l => {
                    if (l.id_mon_tc === actions.payload.id_mon_tc) {
                        return {
                            ...l,
                            ...actions.payload
                        }
                    }
                    return { ...l };
                }),
                status: eReducerStatusBase.is_completed
            }
        case "LOP_TIN_CHI_UPDATE_MON_TIN_CHI_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        case "LOP_TIN_CHI_DANG_KY_TU_DONG_LOP_HANH_CHINH_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving
            }
        case "LOP_TIN_CHI_DANG_KY_TU_DONG_LOP_HANH_CHINH_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload
            }
        case "LOP_TIN_CHI_DANG_KY_TU_DONG_LOP_HANH_CHINH_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            }
        default:
            return state;
    }
}